import type { QueryResult } from '@apollo/client'
import { useCallback } from 'react'

import { useGetSubjectChangeActivities } from '@/lib/apollo/query/getSubjectChangeActivities'
import type { SubjectChangeActivity } from '@/lib/apollo/query/getSubjectChangeActivities/dataTransformations'
import { toSubjectChangeActivity } from '@/lib/apollo/query/getSubjectChangeActivities/dataTransformations'
import type {
  QueryVars,
  Response,
} from '@/lib/apollo/query/getSubjectChangeActivities/query'

type UseSubjectChangeActivities = () => {
  fetchSubjectChangeActivities: (
    customerId: string,
    subjectId: string,
  ) => Promise<QueryResult<Response, QueryVars>>
  loading: boolean
  error: Error | undefined
  data: SubjectChangeActivity[] | undefined
}

const useSubjectChangeActivities: UseSubjectChangeActivities = () => {
  const [fetch, { loading, error, data }] = useGetSubjectChangeActivities({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  })

  const fetchSubjectChangeActivities = useCallback(
    async (customerId: string, subjectId: string) =>
      fetch({
        variables: {
          customerId,
          subjectId,
        },
      }),
    [fetch],
  )

  const transformedData = data?.getSubjectChangeActivities.map(toSubjectChangeActivity)

  return {
    fetchSubjectChangeActivities,
    loading,
    error,
    data: transformedData,
  }
}

export default useSubjectChangeActivities
